/**
 * advertorial.js — Livlab Advertorial v3
 * ════════════════════════════════════════════════════════════
 *
 * La structure des sections est maintenant générée par Liquid.
 * Ce script se charge uniquement de :
 *
 * 1. Barre de progression de lecture
 * 2. Révélation au scroll des blocs .r
 * 3. Animation de la barre de disponibilité
 * ════════════════════════════════════════════════════════════
 */

(function () {
  'use strict';

  /* ════════════════════════════════════════════════════════
     1. BARRE DE PROGRESSION LECTURE
     ════════════════════════════════════════════════════════ */
  function initProgressBar() {
    var bar = document.getElementById('adv-progress');
    if (!bar) return;

    function update() {
      var s = window.scrollY;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = h > 0 ? (s / h * 100) + '%' : '0%';
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ════════════════════════════════════════════════════════
     2. RÉVÉLATION AU SCROLL
     ════════════════════════════════════════════════════════ */
  function initReveal() {
    function reveal() {
      var vh = window.innerHeight;
      document.querySelectorAll('.r:not(.vis)').forEach(function (el) {
        if (el.getBoundingClientRect().top < vh * 0.88) {
          el.classList.add('vis');
        }
      });
    }

    window.addEventListener('scroll', reveal, { passive: true });
    setTimeout(reveal, 80);
    window.addEventListener('load', reveal);
  }

  /* ════════════════════════════════════════════════════════
     3. ANIMATION BARRE DE DISPONIBILITÉ
     ════════════════════════════════════════════════════════ */
  function initAvailabilityBar() {
    var fill = document.querySelector('.adv-progress-fill');
    if (!fill) return;

    var percent = fill.dataset.percent || '62';

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            requestAnimationFrame(function () {
              fill.style.width = percent + '%';
            });
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });

      observer.observe(fill.closest('.adv-progress-wrap') || fill);
    } else {
      setTimeout(function () { fill.style.width = percent + '%'; }, 400);
    }
  }

  /* ════════════════════════════════════════════════════════
     INIT
     ════════════════════════════════════════════════════════ */
  function init() {
    initProgressBar();
    initReveal();
    initAvailabilityBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();